import { KotlinLoggingConfiguration_getInstance2gskotrxa3wxw as KotlinLoggingConfiguration_getInstance } from '../../../../../kotlin-logging/io/github/oshai/kotlinlogging/KotlinLoggingConfiguration.mjs';
import {
  Level_INFO_getInstance1ztv8i0iil2fd as Level_INFO_getInstance,
  Level_DEBUG_getInstance1jqacpbvmckf2 as Level_DEBUG_getInstance,
} from '../../../../../kotlin-logging/io/github/oshai/kotlinlogging/Level.mjs';
import { JsonFormatter_instancekpwk071cdw7n as JsonFormatter_instance } from './JsonFormatter.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function initializeLogging(developmentMode) {
  var tmp = KotlinLoggingConfiguration_getInstance().a2f_1;
  var tmp_0;
  if (developmentMode) {
    tmp_0 = Level_DEBUG_getInstance();
  } else {
    tmp_0 = Level_INFO_getInstance();
  }
  tmp.o2g(tmp_0);
  KotlinLoggingConfiguration_getInstance().a2f_1.p2g(JsonFormatter_instance);
}
//region block: exports
export {
  initializeLogging as initializeLogging2wy35dn799fjs,
};
//endregion

//# sourceMappingURL=InitializeLogging.mjs.map
